import clsx from 'clsx';

/**
 * @param {React.PropsWithChildren<{
 *   active: boolean;
 *   onClick: () => void;
 * }>} props
 *
 * @return {JSX.Element}
 */
export function QuickFiltersItem({ children, active, onClick }) {
  return (
    <button
      className={clsx(
        'block',
        'py-[6px] px-[10px]',
        'rounded-[8px]',
        'text-[14px] leading-normal font-medium text-white',
        'transition-colors',
        active && 'bg-white/20',
      )}
      style={{
        border: '1px solid rgba(255, 255, 255, 0.2)',
      }}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
